import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-organigram-card]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-datalayer-organigram-card-link]').forEach((cardLink) => {
    cardLink.addEventListener('click', datalayerOrganigramCardLink);
  });

  $$('[data-au-datalayer-organigram-card]').forEach((card) => {
    card.addEventListener('click', datalayerOrganigramCard);
  });
}

function datalayerOrganigramCardLink(e) {
  const titleText = e.target
      .closest('[data-au-organigram-card]')
      .querySelector('[data-au-organigram-card-title]').innerText,
    clickText = e.target.querySelector(':not([data-au-icon])').innerText;
  const content_type = 'clickEnlace';

  const item_id = removeAccentMarkAndUppercase(`${titleText}_${clickText}`);

  window.dataLayer.push({
    event: 'navigation',
    content_type,
    item_id,
  });
}

function datalayerOrganigramCard(e) {
  const titleText = e.target
    .closest('[data-au-anchor-content]')
    .querySelector('[data-au-organigram-section-title]').innerText;
  const clickText = e.target
    .closest('[data-au-organigram-card]')
    .querySelector('[data-au-organigram-card-title]').innerText;
  const content_type = 'clickCard';

  const item_id = removeAccentMarkAndUppercase(`${titleText}_${clickText}`);

  window.dataLayer.push({
    event: 'navigation',
    content_type,
    item_id,
  });
}

export default { init };
